<template>
  <div class="animated fadeIn">
    <b-card class="no-border animated">
      <div class="item-header clearfix mb-3">
        <h5 v-if="isEdit" class="pull-left mb-0 mt-2">Edit Shipment: {{number}}</h5>
        <h5 v-if="!isEdit" class="pull-left mb-0 mt-2">Create New Shipment</h5>
      </div>
      <b-form v-on:submit.prevent="onSubmit">
        <legend>Detail Shipment</legend>
        <div class="form-row create-edit-shipment__form">
          <div class="form-group col-md-6">
            <label>Company</label>
            <multiselect
                name="company"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('company')}"
                v-model="selectedCompany"
                :options="companiesData"
                label="name"
                track-by="id"
                placeholder="Select company" class="mb-4"/>
          </div>
          <div class="form-group col-md-6">
            <label>Origin Area</label>
            <multiselect
                name="origin"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('origin')}"
                v-model="form.origin"
                :disabled="disableOriginElem"
                :options="locationsByCompanyId"
                label="name"
                track-by="id"
                placeholder="Select Origin" class="mb-4"/>
          </div>
          <legend>Vehicle</legend>
          <div class="form-group col-md-6">
            <label>Vehicle</label>
            <multiselect
                name="vehicle"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('vehicle')}"
                v-model="selectedVehicle"
                :options="vehicles"
                label="reg_no"
                track-by="id"
                placeholder="Select vehicle" class="mb-4"/>
          </div>
          <div class="form-group col-md-6">
            <label for="shipment_number">Shipment Number</label>
            <input type="text"
              name="shipment number"
              v-validate="'required'"
              :class="{'is-invalid': errors.has('shipment number')}"
              class="form-control"
              id="shipment_number"
              placeholder="Input number"
              v-model="form.number"
              readonly
            >
            <b-form-feedback>{{ errors.first('shipment number') }}</b-form-feedback>
          </div>
          <div class="form-group col-md-6">
            <label>Driver</label>
            <multiselect
                name="driver"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('driver')}"
                v-model="selectedDriver"
                :options="drivers"
                label="name"
                track-by="id"
                placeholder="Select driver" class="mb-4"/>
          </div>
          <div class="form-group col-md-6">
            <label>Loader</label>
            <multiselect
                name="loader"
                v-model="selectedLoader"
                :options="loaderByCompanyId"
                label="name"
                track-by="id"
                placeholder="Select loader" class="mb-4"/>
          </div>
          <div class="form-group col-md-6">
            <label>Type</label>
            <b-form-select v-model="form.type" :options="shipmentTypeOptions"></b-form-select>
          </div>
          <div class="form-group col-md-6" v-if="!isEdit">
            <div class="form-row">
              <b-form-checkbox
                v-model="setShipmentState"
                name="set-shipment-state"
                class="mb-2"
              > Set Shipment State </b-form-checkbox>
              <b-form-select :disabled="!setShipmentState" v-model="selectedState" :options="shipmentStateOptions"></b-form-select>
            </div>
          </div>
          <div v-if="isSchedule" class="form-group col-md-12">
            <div class="form-row">
            <legend>Schedule</legend>
            <div class="form-group col-md-6">
              <label>Delivery Date</label>
              <b-form-datepicker
                v-model="form.delivery_date"
                :min="currentDate"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                locale="en"
                class="mb-2"
                placeholder="Chose a Date"
              >
                </b-form-datepicker>
            </div>
            <div class="form-group col-md-6">
              <label>Shift</label>
              <b-form-select
                v-model="delivery_time"
                :options="[
                  {
                    text: 'Day',
                    value: '04:20',
                  },
                  {
                    text: 'Night',
                    value: '19:30',
                  },
                ]"
              />
            </div>
            </div>
          </div>
        </div>
        <div v-if="!isEdit">
          <legend>Orders</legend>
          <b-card>
            <b-tabs content-class="mt-3" justified>
              <b-tab title="Add New" active>
                <div class="row mb-2">
                  <div class="col-md-12">
                    <label>Order Number</label>
                    <input
                      v-model="currentOrderNumber"
                      class="form-control"
                      type="text"
                      name="order-number"
                      placeholder="Order Number">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label>Customer</label>
                    <multiselect
                        name="customer"
                        v-model="selectedCustomer"
                        :options="customersData"
                        label="name"
                        track-by="id"
                        placeholder="Select customer" class="mb-4"/>
                  </div>
                  <div class="col-md-6">
                    <label>Destination</label>
                    <multiselect
                        name="destination"
                        v-model="selectedDestination"
                        :options="destinationList"
                        label="name"
                        track-by="id"
                        :disabled="disabledDestinationElem"
                        placeholder="Select destination" class="mb-4"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div @click="onShowModalUnit(true)" style="cursor: pointer;" class="text-primary">
                      <i class="fa fa-dropbox" aria-hidden="true"></i>
                      Add Unit
                    </div>
                    <b-list-group>
                      <b-list-group-item v-for="(unit, u_idx) in orderUnitsAdd" :key="unit.number">
                        <div class="pull-left">
                          <strong>{{ unit.number }}</strong> - {{ unit.type }}
                        </div>
                        <div class="pull-right">
                          <b-button
                            @click="removeUnit(u_idx)"
                            title="Remove this unit"
                            variant="outline-danger"
                            class="m-md-2"><i class="fa fa-remove"></i></b-button>
                        </div>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </div>
                <hr>
                <b-button @click="addOrderToList('add_new')" variant="primary">Add to list</b-button>
              </b-tab>
              <b-tab title="From List">
                <label>Orders</label>
                <multiselect
                    name="order"
                    v-model="selectedOrders"
                    :options="orders"
                    :multiple=true
                    label="number"
                    track-by="id"
                    placeholder="Select order" class="mb-4">
                      <template slot="option" slot-scope="props">
                        <span>{{props.option.number}} - {{props.option.customer.name}}</span>
                      </template>
                  </multiselect>
                <b-button @click="addOrderToList('from_list')" variant="primary">Add to list</b-button>
              </b-tab>
            </b-tabs>
          </b-card>
          <b-card>
            <template slot="header">
              Orders
            </template>
            <b-list-group flush>
              <b-list-group-item v-for="(order, idx) in form.orders" :key="order.number">
                <div class="form-row">
                  <div class="col-md-12">
                    <div class="pull-left">
                      <div class="text-primary">{{order.number}}</div>
                      <div class="small text-muted">
                        <i class="fa fa-building-o" aria-hidden="true"></i>
                        {{get(order, 'customer.name')}}
                      </div>
                      <div class="text-muted ">
                        <i class="fa fa-map-pin" aria-hidden="true"></i>
                        {{order.destination.name}}
                      </div>
                    </div>
                    <div class="pull-right">
                      <b-button
                        v-b-toggle="`collapse--unit-${idx}`"
                        variant="outline-primary"
                        class="m-md-2">View unit list</b-button>
                      <b-button
                        @click="removeOrder(idx)"
                        title="Remove this order"
                        variant="outline-danger"
                        class="m-md-2"><i class="fa fa-trash-o"></i></b-button>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-12">
                    <b-collapse :id="`collapse--unit-${idx}`" class="mt-2">
                      <b-list-group>
                        <b-list-group-item v-for="unitItem in order.units" :key="unitItem.number">
                          <strong>{{ unitItem.number }}</strong> - {{ unitItem.type }}
                        </b-list-group-item>
                      </b-list-group>
                    </b-collapse>
                  </div>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-card>
          <b-modal id="order-units-modal" size="lg" v-model="showUnitModal" title="Add Unit">
            <b-container>
              <div class="col-md-12 mb-2">
                <input
                  v-model="currentUnitNumber"
                  class="form-control"
                  type="text"
                  name="unit-number"
                  placeholder="Number">
              </div>
              <div class="col-md-12">
                <input
                  v-model="currentUnitType"
                  class="form-control"
                  type="text"
                  name="unit-type"
                  placeholder="Type">
              </div>
            </b-container>
            <div slot="modal-footer" class="w-100">
              <b-button size="md" class="float-right" variant="primary" @click="addOrderUnit()">
                Add
              </b-button>
              <b-button size="md" class="float-left" variant="warning" @click="onShowModalUnit(false)">
                Close
              </b-button>
            </div>
          </b-modal>
        </div>
        <hr>
        <b-button type="submit" variant="primary">Save changes</b-button>
        <b-button
          @click="onCancel()"
          type="reset"
          variant="outline-secondary"
          class="pull-right">Cancel</b-button>
      </b-form>
    </b-card>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import { isEmpty, filter, isEqual, get, find, sortBy, uniqBy, concat, cloneDeep } from 'lodash';
import { format } from 'date-fns';

export default {
  components: {
    Multiselect,
    DatePicker,
  },
  name: 'shipment_create_edit',
  data() {
    const now = new Date();
    const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return {
      currentDate,
      companiesData: [],
      customersData: [],
      locationsByCompanyId: [],
      loaderByCompanyId: [],
      selectedCompany: null,
      selectedVehicle: null,
      selectedLoader: null,
      selectedDriver: null,
      selectedOrders: null,
      selectedCustomer: null,
      selectedDestination: null,
      destinationList: [],
      currentOrderNumber: null,
      showUnitModal: false,
      currentUnitNumber: null,
      currentUnitType: null,
      orderUnitsAdd: [],
      shipmentTypeOptions: [
        { value: 0, text: 'Delivery' },
        { value: 1, text: 'Pickup' },
      ],
      setShipmentState: false,
      selectedState: 'CREATED',
      shipmentStateOptions: [
        { value: 'CREATED', text: 'CREATED' },
        { value: 'READY_TO_LOAD', text: 'READY TO LOAD' },
        { value: 'FINISH_LOADING', text: 'FINISH LOADING' },
      ],
      form: {
        number: '',
        type: 0,
        origin: '',
        company: '',
        vehicle: '',
        driver_id: '',
        loader: '',
        metadata: '',
        orders: [],
        delivery_date: currentDate,
      },
      delivery_time: null,
    };
  },
  created() {
    const { shipmentId } = this.$route.params;
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'shipments', name: 'Shipments' },
      { to: shipmentId, name: 'Detail' },
      { to: 'edit', name: 'Edit' },
    ];

    if (!this.isEdit) {
      breadcrumb.splice(3, 2);
      breadcrumb.push({ to: 'create', name: 'Create' });
    }

    if (this.isEdit) {
      this.$store.commit('shipment_md/shipments/SET_DETAIL_ID', shipmentId);
      this.$store.dispatch('shipment_md/shipments/LOAD_DETAIL_DATA');
    }

    this.$store.dispatch('shipment_md/orders/LOAD_INFO').then(() => {
      this.$store.commit('shipment_md/orders/SET_QUERY_COUNT', this.count_order_all);
      this.$store.dispatch('shipment_md/orders/LOAD_DATA');
    });
    this.$store.dispatch('shipment_md/shipments/LOAD_LOADERS');
    this.$store.dispatch('shipment_md/shipments/LOAD_DRIVERS');
    this.$store.dispatch('vehicles/LOAD_INFO').then(() => {
      this.$store.commit('vehicles/SET_QUERY_COUNT', this.count_vehicle_all);
      this.$store.dispatch('vehicles/LOAD_DATA');
    });
    this.$store.dispatch('shipment_md/shipments/LOAD_INFO').then(() => {
      this.$store.commit('shipment_md/shipments/SET_QUERY_COUNT', this.count_shipment_all);
      this.$store.dispatch('shipment_md/shipments/LOAD_DATA');
    });
    this.$store.dispatch('shipment_md/shipments/LOAD_LOCATIONS');
    this.loadCompaniesData().then(() => {
      if (!this.isEdit) {
        const defaultCompany = find(this.companiesData, { id: this.myCompany.toString() });
        this.form.company = defaultCompany;
        this.selectedCompany = defaultCompany;
      }
    });
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
  },
  computed: {
    locations() {
      return this.$store.getters['shipment_md/shipments/locations'];
    },
    vehicles() {
      return this.$store.getters['vehicles/vehicles'];
    },
    todayShipments() {
      const shipments = this.$store.getters['shipment_md/shipments/shipments'].filter((shipment) => {
        const updateToday = format(new Date(), 'YYYY-MM-DD') === format(shipment.updated_at, 'YYYY-MM-DD');
        return updateToday;
      });
      return shipments;
    },
    userLoaders() {
      const loaders = this.$store.getters['shipment_md/shipments/loaders'];
      const userLoaders = loaders.filter(l => l.user !== null);
      return userLoaders;
    },
    drivers() {
      const drivers = this.$store.getters['shipment_md/shipments/drivers'].map((drv) => {
        drv.deviceid = this.get(drv, 'metadata.deviceid');
        return drv;
      });
      return sortBy(drivers, ['name']);
    },
    orders() {
      let orders = this.$store.getters['shipment_md/orders/orders'];

      const funcFindOrder = this.form.type === 0
        ? (o) => {
          const isEmptyShipment = isEmpty(o.shipment);
          const isPickupConfirmed = o.type === 'PICKUP' && (o.status === 'CONFIRMED' || o.status === 'CONFIRMED_0');
          const isEditSelected = this.isEdit && o.shipment === this.form.number;
          return isEmptyShipment || isPickupConfirmed || isEditSelected;
        }
        : (o) => {
          const isEmptyShipment = isEmpty(o.shipment);
          const isEditSelected = this.isEdit && o.shipment === this.form.number;
          return isEmptyShipment || isEditSelected;
        };

      orders = orders.filter(funcFindOrder);

      return orders;
    },
    detailedInfo() {
      return this.$store.getters['shipment_md/shipments/get_detail_data'];
    },
    number() {
      return this.detailedInfo.number;
    },
    count_vehicle_all() {
      return this.$store.getters['vehicles/count_all'];
    },
    count_shipment_all() {
      return this.$store.getters['shipment_md/shipments/count_all'];
    },
    count_order_all() {
      return this.$store.getters['shipment_md/orders/count_all'];
    },
    isEdit() {
      return !isEmpty(this.$route.params.shipmentId);
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    disableOriginElem() {
      return isEmpty(this.form.company) || isEmpty(this.locationsByCompanyId);
    },
    myCompany() {
      return this.$store.getters.currentCompany;
    },
    disabledDestinationElem() {
      return !this.selectedCustomer || isEmpty(this.destinationList);
    },
    isSchedule() {
      return get(this.$route.params, 'schedule', false) || get(this.$route.query, 'schedule', false);
    },
  },
  watch: {
    detailedInfo(data) {
      const { form } = this;
      const orders = get(data, 'orders', []);
      const {
        origin,
        company,
        vehicle,
        driver,
        metadata,
      } = data;

      let loader = null;
      if (!isEmpty(metadata)) {
        const loaderId = !metadata.loader_id ? null : metadata.loader_id;

        if (loaderId !== null) {
          loader = find(this.userLoaders, { user: { id: loaderId.toString() } });
        }
      }

      form.delivery_date = data.delivery_date;
      form.number = data.number;
      form.type = data.type;
      form.origin = origin;
      form.driver_id = !isEmpty(driver) ? driver.id : '';
      form.metadata = metadata;
      form.orders = orders.map(order => order.id);
      this.delivery_time = get(metadata, 'delivery_time', '');
      this.selectedCompany = company;
      this.selectedVehicle = vehicle;
      this.selectedLoader = loader;
      this.selectedDriver = driver;
    },
    selectedCompany(newValue) {
      const companyId = !newValue ? null : newValue.id;
      this.form.company = { ...newValue };
      this.locationsByCompanyId.splice(0);
      this.loaderByCompanyId.splice(0);
      this.locationsByCompanyId = filter(this.locations, { company: { id: companyId } });
      this.loaderByCompanyId = filter(this.userLoaders, { company: { id: companyId } });
      if (!isEqual(companyId, get(this.form.origin, 'company.id'))) this.form.origin = [];
    },
    selectedVehicle(data) {
      if (!isEmpty(data)) {
        const uniqShipmentNumb = this.isEdit && this.detailedInfo.number ?
          this.detailedInfo.number : this.createShipmentNumber(data);
        this.form.vehicle = { ...data };
        this.form.number = uniqShipmentNumb;

        const GPSNumber = get(data, 'gps_devices.0.number') || {};
        const relatedDriver = this.isEdit && this.detailedInfo.driver ?
          this.detailedInfo.driver : find(this.drivers, { deviceid: GPSNumber }) || {};
        this.selectedDriver = relatedDriver;
        this.form.driver_id = relatedDriver.id;
      }
    },
    selectedLoader(data) {
      if (!isEmpty(data)) {
        this.form.loader = data.user;
      }
    },
    selectedDriver(data) {
      this.form.driver_id = !isEmpty(data) ? data.id : '';
    },
    selectedCustomer(data) {
      const customerId = !data ? null : data.id;
      this.form.customer = { ...data };
      this.destinationList.splice(0);
      this.destinationList = filter(this.locations, { company: { id: customerId } });
      if (!isEqual(customerId, get(this.selectedDestination, 'company.id'))) {
        this.selectedDestination = [];
      }
    },
  },
  methods: {
    get(obj, key) {
      return get(obj, key) || '';
    },
    onSubmit() {
      this.validate().then((valid) => {
        if (valid) {
          if (this.isSchedule) {
            this.form.delivery_date = format(this.form.delivery_date, 'YYYY-MM-DD');
            if (this.form.metadata === '') {
              this.form.metadata = { delivery_time: this.delivery_time };
            } else {
              if (this.form.metadata === null) this.form.metadata = {};
              this.form.metadata.delivery_time = this.delivery_time;
            }
          } else {
            this.form.delivery_date = format(new Date(), 'YYYY-MM-DD');
          }

          this.form.orders = this.form.orders.map((odr) => {
            odr.type = this.form.type === 0 ? 'DELIVERY' : 'PICKUP';
            return odr;
          });

          const orders = Object.assign([], this.form.orders);
          const deliveryDate = get(this.form, 'delivery_date');
          let { shipmentId } = this.$route.params;
          const action = this.isEdit ? 'UPDATE_DATA' : 'CREATE_DATA';
          const form = cloneDeep(this.form);
          if (!this.isEdit && this.setShipmentState) form.state = this.selectedState;
          this.$store.dispatch(`shipment_md/shipments/${action}`, form).then((shipment) => {
            if (this.isSchedule) {
              if (this.isEdit && orders) {
                const promiseOrders = [];
                orders.forEach((orderId) => {
                  const promise = this.$store.dispatch('shipment_md/orders/UPDATE_DATA', { id: orderId, delivery_date: deliveryDate });
                  promiseOrders.push(promise);
                });
                return Promise.all(promiseOrders).then(() => this.$router.push('/shipment_md/orders/schedule'));
              }
              return this.$router.push('/shipment_md/orders/schedule');
            }
            shipmentId = this.isEdit ? shipmentId : shipment.id;
            return this.$router.push(`/shipment_md/shipments/${shipmentId}`);
          });
        }
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    onCancel() {
      const { shipmentId } = this.$route.params;
      if (this.isSchedule) {
        this.$router.push('/shipment_md/orders/schedule');
      } else if (this.isEdit) {
        this.$router.push(`/shipment_md/shipments/${shipmentId}`);
      } else {
        this.$router.push('/shipment_md/shipments');
      }
    },
    createShipmentNumber(vehicle) {
      const date = format(new Date(), 'YYYYMMDD');
      const vehId = vehicle.id.substring(0, 4).padStart(4, '0');

      const checkLastIncrementShipment = () => {
        const { todayShipments } = this;
        let incNumb = 0;

        todayShipments.forEach((shipment) => {
          const { number: shNumb } = shipment;
          const lastThreeChar = parseInt(shNumb.substr(shNumb.length - 3), 10);

          if (lastThreeChar > incNumb) {
            incNumb = lastThreeChar;
          }
        });
        incNumb += 1;

        return incNumb.toString().padStart(3, '0');
      };
      const incrementNumber = checkLastIncrementShipment();
      const newShipmentNumber = `${date}${vehId}${incrementNumber}`;

      return newShipmentNumber;
    },
    addOrderToList(currentTab) {
      const isAddNew = currentTab === 'add_new';
      const {
        currentOrderNumber,
        selectedCustomer,
        selectedDestination,
        selectedOrders,
        orderUnitsAdd,
      } = this;

      if (isAddNew) {
        if (isEmpty(currentOrderNumber) ||
          isEmpty(selectedCustomer) ||
          isEmpty(selectedDestination)) {
          return false;
        }
        this.form.orders.push({
          number: currentOrderNumber,
          customer: selectedCustomer,
          destination: selectedDestination,
          units: orderUnitsAdd,
        });
        this.currentOrderNumber = '';
        this.selectedCustomer = null;
        this.selectedDestination = null;
        this.orderUnitsAdd = [];
      } else {
        if (isEmpty(selectedOrders)) {
          return false;
        }
        selectedOrders.forEach((order) => {
          const available = find(this.form.orders, { id: order.id });
          if (isEmpty(available)) {
            this.form.orders.push(order);
          }
        });
        this.selectedOrders = [];
      }
      return true;
    },
    removeOrder(orderIndex) {
      this.form.orders.splice(orderIndex, 1);
    },
    removeUnit(unitIndex) {
      this.orderUnitsAdd.splice(unitIndex, 1);
    },
    onShowModalUnit(show) {
      this.showUnitModal = show;
    },
    addOrderUnit() {
      if (isEmpty(this.currentUnitNumber) || isEmpty(this.currentUnitType)) {
        return false;
      }

      this.orderUnitsAdd.push({
        number: this.currentUnitNumber,
        type: this.currentUnitType,
      });

      this.showUnitModal = false;
      this.currentUnitNumber = null;
      this.currentUnitType = null;

      return true;
    },
    loadCompaniesData() {
      return Promise.all([
        this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: 0 }),
        this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: 1 }),
      ]).then((data) => {
        const companies = data[0] || [];
        const customers = companies.filter(dt => dt.type === 'CUSTOMER');
        const tenants = data[1];
        this.companiesData = companies;
        this.customersData = !this.isSystemAdmin ? uniqBy(concat(customers, tenants), 'id') : companies;
      });
    },
  },
};
</script>
<style lang="sass">
@import "~vue-multiselect/dist/vue-multiselect.min"
.multiselect-danger .multiselect__tags
  border: 1px solid #f86c6b

.create-edit-shipment__form
  .multiselect
    z-index: 0
  .multiselect--active
    z-index: 9999
  .multiselect--active
    .multiselect__content-wrapper
      z-index: 9999 !important
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/shipments/CreateEdit.vue